import {
  CButton,
  CCardHeader,
  CCol,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import React from "react";
// import usersData from "../users/UsersData";

const PaymentDetail = () => {
  return (
    <>
      <CCardHeader className="mb-5">
        <CRow xl={12} className="pt-3">
          <CCol xl={10}>
            <h3>Payment Details</h3>
          </CCol>
        </CRow>
        <hr />
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Total Purchase Price:
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <CInput placeholder="" />
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Pay(10%):
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <CInput placeholder="" />
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Paid Lot EMD(10%):
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <CInput placeholder="" />
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Paid Lot EMD(15%):
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <CInput placeholder="" />
          </CCol>
        </CRow>

        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Remaining to Pay:
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <CInput placeholder="" disabled />
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}></CCol>
          <CCol xl={3}>
            <input id="checkboxLabel" type="checkbox" />
            <span className="offset-1">
              I agree with Term and Condition of Sanction Letter.
            </span>
          </CCol>
        </CRow>
        {/* <CRow className="mb-3">
          <CCol xl={2}>
            <input id="checkboxLabel" type="checkbox" className="col-sm-12 " />
          </CCol>
          <CCol xl={2}>
            <CLabel>I agree with Term and Condition of Sanction Letter.</CLabel>
          </CCol>
        </CRow> */}
        <CRow className="mb-3">
          <CCol xl={2}>
            <CButton className="ml-3" color="success">
              Back
            </CButton>
            <CButton className="ml-3" color="success">
              Next
            </CButton>
          </CCol>
        </CRow>
      </CCardHeader>
    </>
  );
};
export default PaymentDetail;
